import { render, staticRenderFns } from "./SetupTestPage3.vue?vue&type=template&id=1f05217a&scoped=true&"
import script from "./SetupTestPage3.vue?vue&type=script&lang=js&"
export * from "./SetupTestPage3.vue?vue&type=script&lang=js&"
import style0 from "./SetupTestPage3.vue?vue&type=style&index=0&id=1f05217a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f05217a",
  null
  
)

export default component.exports